import bg_factoring from 'assets/svg/factoring/bg-factoring-reverse.svg';
import IconPolygon from 'assets/svg/factoring/polygon.inline.svg';
import IconDollar from 'assets/svg/icons/dollar.inline.svg';
import ButtonLink from 'components/Molecules/ButtonLink';
import SEO from 'components/SEO';
import { routes } from 'constants/routes';
import { Link } from 'gatsby';
import React from 'react';
import { css } from 'twin.macro';

const bgFactoring = css`
	height: 42vw;
	position: relative;
	background-image: url(${bg_factoring});
	background-position: center;
	background-repeat: no-repeat;
	background-size: contain;
`;

export default function factoringReverse() {
	return (
		<div>
			<SEO
				title='Faktoring odwrotny - wszystko co powinieneś wiedzieć / Jak działa faktoring odwrotny?'
				description='Faktoring odwrotny jest szczególnie polecany przedsiębiorstwom, które mają stałych dostawców i bardzo krótkie terminy płatności za towary lub usług lub takich, którzy wymagają przedpłat lub płatności gotówką przy odbiorze. Poza tym, faktoring odwrotny będzie opłacał się wówczas, gdy dostawca zaproponuje Ci rabaty za przedterminową zapłatę za zamówione towary lub usługi. W takiej sytuacji może się bowiem okazać, że nawet fakt obowiązku zapłacenia odsetek faktorowi będzie dla Ciebie korzystniejszy niż kupowanie towarów lub usług w standardowej cenie. Tą samą cechę mają zresztą podobnie umowy faktoringu pełnego i niepełnego. Funkcja finansowa faktoringu odwrotnego polega na spłacie zobowiązań Faktoranta oraz zazwyczaj dodatkowo na wydłużeniu terminu ich płatności do Faktora.'
				keywords='faktoring, faktoring odwrotny'
				contentType='article'
			/>

			<div css={bgFactoring} className='flex flex-col items-center justify-between pt-30'>
				<IconPolygon width='7rem' height='7rem' />
			</div>

			<p className='text-center text-20 font-bold mb-30'>Faktoring odwrotny</p>

			<div className='px-20'>
				<p>Faktoring odwrotny inaczej zobowiązaniowy albo zakupowy to wspólna nazwa dla tego samego rodzaju faktoringu. Faktoring odwrotny oznacza nabywanie przez firmę faktoringową (czyli Faktora) zobowiązań Twojej firmy w stosunku do Twoich dostawców, za określoną cenę.</p>
				<p>
					Faktoring odwrotny jest szczególnie polecany przedsiębiorstwom, które mają stałych dostawców i bardzo krótkie terminy płatności za towary lub usług lub takich, którzy wymagają przedpłat lub płatności gotówką przy odbiorze. Poza tym, faktoring odwrotny będzie opłacał się wówczas, gdy dostawca zaproponuje Ci rabaty za przedterminową zapłatę za zamówione towary lub usługi. W takiej sytuacji może się bowiem okazać, że nawet fakt obowiązku zapłacenia odsetek faktorowi będzie dla Ciebie korzystniejszy niż kupowanie towarów lub usług w standardowej cenie. Tą samą cechę mają zresztą podobnie umowy faktoringu pełnego i niepełnego.
					Funkcja finansowa faktoringu odwrotnego polega na spłacie zobowiązań Faktoranta oraz zazwyczaj dodatkowo na wydłużeniu terminu ich płatności do Faktora.
				</p>

				<p className='text-16 mb-10 mt-40'>Dla kogo faktoring odwrotny</p>
				<p>
					Ten typ finansowania przyda się szczególnie przedsiębiorcom, którzy dopiero wyrabiają sobie renomę u swoich dostawców. Dodatkowe środki, jakie zapewnia w tym przypadku Faktor pozwolą zdobyć nowych klientów, albo wynegocjować korzystniejsze ceny i warunki umowy z dostawcami.
					Faktoring odwrotny przyda się również firmom, które muszą szybko regulować płatności do swoich dostawców, co w długim terminie może wiązać się utratą płynności finansowej. Pośrednictwo faktora pozwala tutaj znacznie ograniczyć ryzyko niewypłacalności, oraz zdobyć dodatkowe środki na reorganizację polityki zaopatrzeniowej.
				</p>

				<p className='text-16 mb-10 mt-40'>Zalety faktoringu odwrotnego</p>
				<div>Niewątpliwą zaletą faktoringu odwrotnego jest możliwość sfinansowania zakupu towarów lub usług bez angażowania własnych środków obrotowych. Zamiast zamrażać własny kapitał w towarach lub półproduktach, które przez większość czasu oczekują na sprzedaż w magazynie lub na produkcji, firma wykorzystuje kapitał Faktora do finansowania swoich zobowiązań, nierzadko wydłużając dodatkowo ich termin płatności.  Taka konstrukcja ma duży sens, zwłaszcza w przypadku, gdy klient nie ma możliwości skorzystania z faktoringu
					&nbsp;<Link to={routes.FACTORING_INCOMPLETE} className='link-in-text'>wierzytelnościowego</Link>. Jest to cecha charakterystyczna dla przedsiębiorstw sprzedających głównie za gotówkę lub przeważnie dla klienta detalicznego (np. sklepy spożywcze, odzieżowe, apteki itp.)
				</div>

				<ButtonLink to={`${routes.CONTACT}?scrollIntoContact`} primary tw='mt-10 mb-20 bg-main my-40 mx-auto'>
					<IconDollar/><p>Wyślij wiadomość</p>
				</ButtonLink>
			</div>
		</div>
	);
}
